import { useState, useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppContext } from '../../context/AppContext';
import { validateEmail } from '../../utils/validation';
import { api } from '../../services/api';

const PayPalConnectModal = ({ open, onClose, onSuccess }) => {
  const { storeId } = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) {
      setError('');
    }
  };

  const handleConnect = async () => {
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      return;
    }
    if (storeId == null) {
      setError('Store is not available.');
      return;
    }

    setSubmitting(true);
    try {
      await api.activatePayPal(storeId, email);
      onSuccess?.();
      handleClose();
    } catch (err) {
      setError(err?.message || 'Failed to connect PayPal.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Connect with PayPal
          </Typography>
          <IconButton onClick={handleClose} size="small" disabled={submitting}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 3 }}>
          In order to receive payments to your{' '}
          <Typography component="span" sx={{ color: 'primary.main', fontWeight: 600 }}>
            PayPal
          </Typography>{' '}
          account, we have to know your PayPal merchant email.
        </Typography>
        <TextField
          label="Email Address"
          type="email"
          value={email}
          onChange={handleEmailChange}
          error={!!error}
          helperText={error}
          placeholder="Enter your PayPal merchant email"
          fullWidth
          required
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={handleClose} variant="outlined" sx={{ color: 'text.secondary' }} disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleConnect}
          variant="contained"
          color="inherit"
          disabled={submitting}
          sx={{
            backgroundColor: '#616161',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#616161',
            },
          }}
        >
          {submitting ? <CircularProgress size={22} color="inherit" /> : 'Connect with PayPal'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PayPalConnectModal;

